import { useAuth0 } from '@auth0/auth0-react';
import Router from 'next/router';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Error from '@/pages/_error';
import TermsConditionModal from '@/src/forum/components/TermsConditionModal';
import Layout from '@/src/shared/components/Layout';
import LoadingPage from '@/src/shared/components/LoadingPage/LoadingPage';
import { checkAccess, COMPLIANCE_ACCESS } from '@/src/shared/constants';
import request from '@/utils/axios';

import { setForumTermsDue } from '../../redux/forumReducer';

const withForumTermsWrap = ForumPageComponent => {
  return function ForumWrap(props) {
    const dispatch = useDispatch();
    const { isLoading, loginWithRedirect } = useAuth0();

    const { isLoggedIn, role } = useSelector(state => state.auth);
    const stateLoading = useSelector(state => state.auth.isLoading);
    const personId = useSelector(state => state.auth.userinfo.PersonID);
    const emailAddress = useSelector(state => state.auth.userinfo.emailaddress);
    const { termsDue } = useSelector(state => state.forum);

    const [termsData, setTermsData] = useState({});
    const [termsLoading, setTermsLoading] = useState(true);
    const [error, setError] = useState(false);

    const setTermsDue = payload => {
      dispatch(setForumTermsDue(payload));
    };

    const hasAccess = checkAccess(COMPLIANCE_ACCESS.MARKET_CONDUCT, role);
    const isAuthorized = personId && Array.isArray(role) && hasAccess;
    const errorCode = isLoggedIn && !hasAccess ? 401.4 : 401;

    if (!stateLoading && !isLoggedIn) {
      loginWithRedirect({
        appState: {
          returnTo: Router.pathname,
        },
      });
    }

    useEffect(() => {
      if (emailAddress) {
        (async () => {
          if (termsDue !== null) {
            setTermsLoading(false);
            return;
          }
          const { data } = await request({
            url: 'marketconduct/IsTermsAndConditionsDue',
            params: { emailAddress },
          });
          if (data.Success === 'true') {
            setTermsDue(data.termsDue);
            if (data.termsDue) {
              const {
                data: { Body, MetaTitle },
              } = await request({
                url: 'cms/contentpage',
                params: {
                  corePageId: 607,
                },
              });
              setTermsData({ Body, MetaTitle });
            }
          } else {
            setError(true);
          }
          setTermsLoading(false);
        })();
      }
    }, [emailAddress, termsDue]);

    const handleAccept = async () => {
      const { data } = await request({
        url: 'marketconduct/AcceptedTerms',
        method: 'POST',
        params: { emailAddress },
      });
      if (data.Success === 'true') {
        setTermsDue(false);
      }
    };

    if (!stateLoading && isLoggedIn && !isAuthorized) return <Error status={errorCode} />;
    if (isLoading || stateLoading) return <LoadingPage />;
    if (isLoading) return null;
    if (!isLoggedIn || !isAuthorized || error) return <Error status={errorCode} />;

    const renderContent = () => {
      if (termsDue || termsLoading) {
        return null;
      }
      return <ForumPageComponent personId={personId} />;
    };

    return (
      <Layout>
        <TermsConditionModal
          visible={termsDue}
          data={termsData}
          loading={termsLoading}
          handleAccept={handleAccept}
        />
        {renderContent()}
      </Layout>
    );
  };
};

export default withForumTermsWrap;
